module.exports = __webpack_public_path__ + "static/media/AGalaxyofWhalesBookCover.40f90e05.jpg";